<template>
  <div class="headPortrait">
    <div class="editData_tipbox">
      <Vue-imageCutting
        :picturePath="picturePathData"
        :buttonColor="buttonColorData"
        :backgroundColor="backgroundColorData"
        :iconColor="iconColorData"
        :format="formatData"
        :crossDomain="crossDomainData"
        :maskOpacity="maskOpacityData"
        :minZoom="minZoomData"
        :maxZoom="maxZoomData"
        @confirm="confirmMethod"
        @loading="loadingMethod"
        @cancel="cancelMethod"
      />
      <div class="loading_box" v-show="loadingFlag">
        <van-loading type="spinner" color="#1989fa" />
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import get from "../../../../api/get";
import * as _code from "../../../../utils/code";
export default {
  name: "headPortrait",
  props: {
    picturePathData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loadingFlag: false,
      stabilization: true, //提交放多次点击
      maskOpacityData: 0.7, //蒙层透明度
      formatData: "jpeg",
      minZoomData: 0.5, //允许缩小的最小倍数
      crossDomainData: false, //是否通过img标签的crossorigin属性请求跨域资源
      maxZoomData: 3, //允许放大的最大倍数
      iconColorData: "#ffffff", //旋转与复原按钮颜色
      backgroundColorData: "#000000", //背景色
      buttonColorData: "transparent", //确认按钮的背景色

      qaFlag: /^(test|qa)-/.test(location.hostname),
      Bucket: "",
      Region: "",
      allowPrefix: "",
      protocol: "https:",
    };
  },
  methods: {
    //点击取消时触发
    cancelMethod(event) {
      this.$emit("cancelMethod");
    },
    //图片加载结束后触发，成功LoadingStatus:true，失败LoadingStatus:false
    loadingMethod(event) {
      console.log(event);
    },
    //点击确认按钮时触发,返回裁剪后的base64
    confirmMethod(event) {
      this.loadingFlag = true;
      if (this.stabilization) {
        this.stabilization = false;
        this.dataURLtoFile(event.base64);
      }
    },

    //base64转png
    dataURLtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let file = new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
      this.upload(file);
    },
    //储存腾讯云
    upload(file) {
      let _this = this;
      if (file.size) {
        if ((file.size / (1024 * 1024)).toFixed(3) <= 5) {
          //小于5M
          file.newName = "_" + +new Date() + "." + file.name.split(".")[1];
          try {
            file &&
              _this.uploadFile(file, function (err, data) {
                let url = data.url.replace(
                  "snspic-1251257918.cos.ap-shanghai.myqcloud.com",
                  "snspic.zlongame.com"
                );
                if (data) {
                  _this.$emit("setHeader", url, () => {
                    _this.stabilization = true;
                  });
                  this.loadingFlag = false;
                } else {
                  this.loadingFlag = false;
                  Dialog.alert({
                    message: err,
                  });
                }
              });
            // });
          } catch (err) {
            this.loadingFlag = false;
            Dialog.alert({
              message: err,
            });
          }
        } else {
          this.loadingFlag = false;
          Dialog.alert({
            message: "图片太大啦！请选择5M以内的图片上传哦~",
          });
        }
      }
    },
    uploadFile(file, callback, obj) {
      var self = this;
      var Key =
        // "sns/front/" +
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1) +
        "/" +
        file.newName; // 这里指定上传目录和文件名
      self.getAuthorization(
        { Method: "PUT", Pathname: "/" + Key },
        function (err, info) {
          if (err) {
            alert(err);
            return;
          }
          let prefix =
            self.protocol +
            "//" +
            self.Bucket +
            ".cos." +
            self.Region +
            ".myqcloud.com/";
          var auth = info.Authorization;
          var XCosSecurityToken = info.XCosSecurityToken;
          var url =
            prefix +
            self.allowPrefix +
            self.camSafeUrlEncode(Key).replace(/%2F/g, "/");
          var xhr = new XMLHttpRequest();
          xhr.open("PUT", url, true);
          xhr.setRequestHeader("Authorization", auth);
          XCosSecurityToken &&
            xhr.setRequestHeader("x-cos-security-token", XCosSecurityToken);
          xhr.upload.onprogress = function (e) {
            if (obj) {
            }
          };
          xhr.onload = function () {
            if (xhr.status === 200 || xhr.status === 206) {
              var ETag = xhr.getResponseHeader("etag");
              callback(null, { url: url, ETag: ETag });
            } else {
              callback("上传失败，状态码：" + xhr.status);
            }
          };
          xhr.onerror = function () {
            callback("上传失败，请检查是否配置跨域规则");
          };
          xhr.send(file);
        }
      );
    },
    // 计算签名
    getAuthorization(options, callback) {
      get.getCosTemToken().then((res) => {
        var data;
        try {
          data = new Function("return " + JSON.stringify(res.data.data))();
          this.allowPrefix = data.allowPrefix;
          this.Region = data.region;
          this.Bucket = data.bucketName;
        } catch (res) {}
        if (data) {
          callback(null, {
            XCosSecurityToken: data.credentials.sessionToken,
            Authorization: CosAuth({
              SecretId: data.credentials.tmpSecretId,
              SecretKey: data.credentials.tmpSecretKey,
              Method: options.Method,
              Pathname: options.Pathname,
            }),
          });
        } else {
          callback("获取签名出错");
        }
      });
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A");
    },
  },
};
</script>
<style scoped>
</style>